import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const CharacterCount = ({ id, maxLength, children, characterCount, ...props }) => {
    const hasExceededLength = () => {
        return (characterCount ?? 0) > (maxLength ?? 0);
    };

    return (<div className="govuk-character-count" data-module="govuk-character-count" data-maxlength={maxLength}>
        {children}
        <div id={id ? id + '-info' : null} className={['govuk-character-count__message', 'govuk-character-count__sr-status', (hasExceededLength() ? 'govuk-error-message' : 'govuk-hint')].join(' ')} data-testid={props['data-testid'] ? props['data-testid'] + '-character-count' : null} aria-live='polite'>
            {
                hasExceededLength()
                    ? <FormattedMessage
                        id="characterCount.overCountMessage"
                        values={{
                            excessCharacterCount: String(Math.abs((maxLength ?? 0) - (characterCount ?? 0)))
                        }}
                    />
                    : <FormattedMessage
                        id="characterCount.underCountMessage"
                        values={{
                            remainingCharacterCount: String(Math.abs((maxLength ?? 0) - (characterCount ?? 0)))
                        }}
                    />
            }
        </div>
    </div>);
};

CharacterCount.propTypes = {
    id: PropTypes.string,
    maxLength: PropTypes.number,
    children: PropTypes.element,
    characterCount: PropTypes.number,
    'data-testid': PropTypes.string
};

CharacterCount.defaultProps = {
    maxLength: 200
};

export default CharacterCount;
